import PendingGuest from '@/components/notifications/PendingGuest.vue'

export default {
  // namespaced: true,
  state: {
    ifLoadingParticipants: false,
    spaceParticipants: [],
    // pagination
    spaceParticipantPagination: {},
    ifLoadingMoreParticipants: false,
  },

  getters: {
    ifLoadingParticipants: state => state.ifLoadingParticipants,
    spaceParticipants: state => state.spaceParticipants,

    spaceParticipantPagination: state => state.spaceParticipantPagination,
    isLoadingMoreParticipants: state => state.ifLoadingMoreParticipants,
    isThereMoreParticipants: state => {
      const pagination = state.spaceParticipantPagination
      return pagination.currentPage < pagination.numberOfPages
    },
  },

  mutations: {
    LOADING_PARTICIPANTS(state, value) {
      state.ifLoadingParticipants = value
    },

    SPACE_PARTICIPANTS(state, value) {
      state.spaceParticipants = value
    },
    SPACE_PARTICIPANT_PAGINATION(state, value) {
      state.spaceParticipantPagination = value
    },
    LOADING_MORE_PARTICIPANTS(state, value) {
      state.ifLoadingMoreParticipants = value
    }
  },

  actions: {
    async addToSpaceParticipants({getters,commit}, data) {
      let moreParticipants = [...getters.spaceParticipants, ...data]
      commit('SPACE_PARTICIPANTS', moreParticipants)
    },
    async removeFromSpaceParticipants({getters,commit}, userId) {
      if(!userId) return console.log('no user id given')
      let lessParticipants = []
      getters.spaceParticipants.map(part => {
        if(part.userId !== userId) lessParticipants.push(part)
      })
      if(lessParticipants !== getters.spaceParticipants) commit('SPACE_PARTICIPANTS', lessParticipants)
    },
    async clearSpaceParticipants({commit}) {
      commit('SPACE_PARTICIPANTS', [])
      commit('LOADING_PARTICIPANTS', false)
      commit('LOADING_MORE_PARTICIPANTS', false)
      commit('SPACE_PARTICIPANT_PAGINATION', {})
    },
    // pagination
    async refreshSpaceParticipants({dispatch}) {
      await dispatch('fetchCurrentSpaceParticipants')
    },
    // handle get participants
    async fetchCurrentSpaceParticipants({rootGetters,commit,dispatch}, data = {}) {
      let {id = '', page = 1} = data
      // todo: ignore stale requests
      if(!id) {
        id = rootGetters.getSpacePageId
      }
      commit('LOADING_PARTICIPANTS', true)
      let res
      if(data.portal) res = await dispatch('api/search/spacePortalParticipants', [id, page], {root: true})
      else res = await dispatch('api/search/roomParticipants', [id, page], {root: true})
      commit('LOADING_PARTICIPANTS', false)
      if(res.success) {
        commit('SPACE_PARTICIPANTS', res.success.results)
        commit('SPACE_PARTICIPANT_PAGINATION', res.success.pagination)
      } else {
        console.log('error getting space participants')
      }
      return res
    },
    async handleSpaceParticipantsUpdate({commit}, data) {
      commit('SPACE_PARTICIPANTS', data.results)
      commit('SPACE_PARTICIPANT_PAGINATION', data.pagination)
    },
    // handle get more participants on scroll participants
    async fetchMoreSpaceParticipants({getters,rootGetters,commit,dispatch}) {
      // todo: ignore stale requests
      console.log('get more participants')
      let id = rootGetters.getSpacePageId
      let page = getters.spaceParticipantPagination.currentPage + 1
      if(!id || !page || page > getters.spaceParticipantPagination.numberOfPages) return

      commit('LOADING_MORE_PARTICIPANTS', true)
      let res = await dispatch('api/search/roomParticipants', [id, page], {root: true})
      commit('LOADING_MORE_PARTICIPANTS', false)
      if(res.success) {
        dispatch('addToSpaceParticipants',res.success.results)
        commit('SPACE_PARTICIPANT_PAGINATION', res.success.pagination)
      } else {
        console.log('error getting more space participants')
      }
      return res
    },

    async checkForGuestsInRoomLobby({getters, rootGetters, commit, dispatch}) { //check for pending lobby guests on join room
      if(!rootGetters['permissions/isAllowed']('room.lobby.acceptOrDeny')) return
      await dispatch('fetchCurrentSpaceParticipants')
      let pending = getters.spaceParticipants.filter(p => p.inLobby && p.userId !== rootGetters['current_user/id'])
      if(pending[0]) {
        commit('guest/room/CURRENT_PENDING_GUEST', {
          ...pending[0],
          username: pending[0].fullName,
          locationId: rootGetters['getSpacePageId']
        }, {root: true})
        dispatch('modal/open', [PendingGuest], {root: true})
        dispatch('sidebar/updatePanelId', 'info', {root: true})
      }
    },
  }
};
